<table class="table-list">
  <thead>
  <tr>
    <th>{{ tabName === 'DEALER' ? 'Dealer' : 'Agent Name' }}</th>
    <th>{{ tabName === 'DEALER' ? 'Store' : 'Email' }}</th>
    <th>Total</th>
    <th>0</th>
    <th>1</th>
    <th>2</th>
    <th>3</th>
    <th>4</th>
    <th>5</th>
    <th>6</th>
    <th>7</th>
    <th>8</th>
    <th>9</th>
    <th>10</th>
    <th>11</th>
    <th>12</th>
    <th>13</th>
    <th>14</th>
    <th>15</th>
    <th>16+</th>
    <th>30+</th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let summary of summaryDateData; let i=index;"
      class="shadow-sm">
    <td>{{ tabName === 'DEALER' ? summary.dealerName : summary.agentName || '' }}</td>
    <td>{{ tabName === 'DEALER' ? summary.dealerStoreName : summary.username }}</td>
    <td class="number-td">
      <div class="number">{{ summary.total | number: '1.0-0' }}</div>
    </td>
    <td class="number-td">
      <div class="number">{{ summary.zero | number: '1.0-0' }}</div>
    </td>
    <td class="number-td">
      <div class="number">{{ summary.one | number: '1.0-0' }}</div>
    </td>
    <td class="number-td">
      <div class="number">{{ summary.two | number: '1.0-0' }}</div>
    </td>
    <td class="number-td">
      <div class="number">{{ summary.three | number: '1.0-0' }}</div>
    </td>
    <td class="number-td">
      <div class="number">{{ summary.four | number: '1.0-0' }}</div>
    </td>
    <td class="number-td">
      <div class="number">{{ summary.five | number: '1.0-0' }}</div>
    </td>
    <td class="number-td">
      <div class="number">{{ summary.six | number: '1.0-0' }}</div>
    </td>
    <td class="number-td">
      <div class="number">{{ summary.seven | number: '1.0-0' }}</div>
    </td>
    <td class="number-td">
      <div class="number">{{ summary.eight | number: '1.0-0' }}</div>
    </td>
    <td class="number-td">
      <div class="number">{{ summary.nine | number: '1.0-0' }}</div>
    </td>
    <td class="number-td">
      <div class="number">{{ summary.ten | number: '1.0-0' }}</div>
    </td>
    <td class="number-td">
      <div class="number">{{ summary.eleven | number: '1.0-0' }}</div>
    </td>
    <td class="number-td">
      <div class="number">{{ summary.twelve | number: '1.0-0' }}</div>
    </td>
    <td class="number-td">
      <div class="number">{{ summary.thirteen | number: '1.0-0' }}</div>
    </td>
    <td class="number-td">
      <div class="number">{{ summary.fourteen | number: '1.0-0' }}</div>
    </td>
    <td class="number-td">
      <div class="number">{{ summary.fifteen | number: '1.0-0' }}</div>
    </td>
    <td class="number-td">
      <div class="number red">{{ summary.sixteen | number: '1.0-0' }}</div>
    </td>
    <td class="number-td">
      <div class="number red">{{ summary.thirty | number: '1.0-0' }}</div>
    </td>
  </tr>
  </tbody>
</table>
<div *ngIf="!summaryDateData?.length" class="align-center">
  <font-awesome [icon]="'fa-light fa-file-circle-exclamation'"></font-awesome>
  <span class="pl-14px">No results found</span>
</div>

